module.exports = __webpack_public_path__ + "media/images/icons/country_flags/aq-2405e38d3ce9174eee6079dcd242abbe.svg";